/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Err_Missing_Title_MsgInputs */

const es_cap_err_missing_title_msg = /** @type {(inputs: Cap_Err_Missing_Title_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona tu titulación.`)
};

const gl_cap_err_missing_title_msg = /** @type {(inputs: Cap_Err_Missing_Title_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona a túa titulación.`)
};

const en_cap_err_missing_title_msg = /** @type {(inputs: Cap_Err_Missing_Title_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select your licence.`)
};

/**
* | output |
* | --- |
* | "Select your licence." |
*
* @param {Cap_Err_Missing_Title_MsgInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_err_missing_title_msg = /** @type {((inputs?: Cap_Err_Missing_Title_MsgInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Err_Missing_Title_MsgInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_err_missing_title_msg(inputs)
	if (locale === "en") return en_cap_err_missing_title_msg(inputs)
	return es_cap_err_missing_title_msg(inputs)
});